import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

const base_url = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class MarketingHttpService {
  constructor(private httpClient: HttpClient) {}

  public sendEmail(data): Observable<any> {
    return this.httpClient.post(`${base_url}support/email`, data);
  }
}
